import { datadogRum } from '@datadog/browser-rum';
import { useDispatch } from 'react-redux';
import { useDeepCompareEffect, useLocation } from 'react-use';

import {
  useCurrentUser,
  useLoginStore,
} from '@savgroup-front-common/core/domains/login/useLoginStore';
import {
  buildErrorNotification,
  getUniqErrorMessages,
} from '@savgroup-front-common/core/helpers';

import { signIn } from '@/domains/Login/loginActions';

import AppRoutes from '../AppRoutes';

import { useAuth } from './AuthProviderContext';
import LoadingScreen from './LoadingScreen';

const CheckAuthorized = () => {
  const { pathname, search } = useLocation();
  const authenticatedUser = useCurrentUser();
  const setLoginStore = useLoginStore((state) => state.setLoginStore);
  const errors = authenticatedUser?.errors;

  const { user, isAuthenticated, login } = useAuth();

  const dispatch = useDispatch();

  useDeepCompareEffect(() => {
    if (user && isAuthenticated) {
      if (!authenticatedUser.isLoaded) {
        dispatch(signIn({ setLoginStore }) as any);
      }

      return;
    }

    login({
      state: {
        redirectUrl: `${pathname}${search}`,
      },
    });
  }, [
    dispatch,
    isAuthenticated,
    login,
    pathname,
    search,
    user,
    setLoginStore,
    authenticatedUser.isLoaded,
  ]);

  const notifications = getUniqErrorMessages(errors || []).map(
    buildErrorNotification,
  );

  if (!user || !isAuthenticated || !authenticatedUser.isLoaded) {
    return <LoadingScreen notifications={notifications} />;
  }

  datadogRum.setUser({
    id: authenticatedUser.userId || authenticatedUser.id,
    name: `${authenticatedUser.firstname || authenticatedUser.firstName} ${
      authenticatedUser.lastname || authenticatedUser.lastName
    }`,
    email: authenticatedUser.mail || authenticatedUser.email,
    accesses: authenticatedUser.accesses,
    permissions: authenticatedUser.permissions,
  });

  return <AppRoutes />;
};

export default CheckAuthorized;
